export default {
    "خانه": "Home",
    "انتخاب آدرس": "Choose Address",
    "محصولات": "Products",
    "لیست فروشگاه ها": "Shops",
    "اخذ نمایندگی": "Representation",
    "فرصت شغلی": "Job Opportunities",
    "درباره کلانا": "About Cluna",
    "تماس با ما": "Contact Us",
    "ثبت نظر و پیشنهاد": "Submit Suggestions",
    "انتخاب گزینه های": "Select Options",
    "برای اعمال لمس کنید": "Tap to Submit",
    "افزودن": "Add",
    "جزئیات خرید": "Purchase Details",
    "تومان": "Tomans",
    "هزینه ارسال با پیک": "Cost of Delivery",
    "پیگیری سفارش": "Order Tracking",
    "خرید شما از اعتبار انجام شد، به بخش پیگیری سفارشات بروید": "Your Order Was Paid Using Credit, Please Visit the Order Tracking Page",
    "اول": "First",
    "دوم": "Second",
    "سوم": "Third",
    "چهارم": "Fourth",
    "پنجم": "Fifth",
    "ششم": "Sixth",
    "هفتم": "Seventh",
    "هشتم": "Eighth",
    "نهم": "Ninth",
    "دهم": "Tenth",
    "سفارش حضوری (تحویل در فروشگاه)": "In-Store Pickup",
    "در صورت انتخاب این گزینه، میبایست جهت تحویل گرفتن سفارش به صورت حضوری به فروشگاه مراجعه کنید و سفارش خود را با اعلام کد سفارش تحویل بگیرید": "If You Choose This Option, You Must Visit the Store to Collect Your Order Using the Order Code",
    "سفارش دلیوری (تحویل درب منزل)": "Home Delivery",
    "فروشگاه انتخاب شده، دارای قابلیت ارسال با پیک جهت تحویل درب منزل میباشد. توجه فرمائید محدوده ارسال تا شعاع 1.5 کیلومتری میباشد. هزینه پیک نیز به صورت جداگانه محاسبه خواهد شد.": "The Selected Store Offers Delivery Service. The Delivery Radius Is 1.5 km, and the Delivery Fee Will Be Charged Separately.",
    "هزینه ملزومات سفارش": "Order Supplies Cost",
    "استفاده از اعتبار کیف پول": "Use Wallet Credit",
    "مبلغ نهایی سفارش": "Final Order Amount",
    "تحویل درب فروشگاه": "Pickup at Store",
    "تحویل درب منزل": "Delivery to Home",
    "ویرایش و حذف آدرس های من": "Edit/Delete My Addresses",
    "برای ویرایش و یا حذف آدرس های ثبت شده خود از این بخش استفاده کنید": "Use This Section to Edit or Delete Your Saved Addresses",
    "بستن سبد خرید": "Close Cart",
    "ورود / ثبت نام حساب کاربری": "Login / Register",
    "برای ایجاد سفارش و استفاده از امکانات سایت شماره موبایل 11 رقمی خود را وارد نمایید.": "Enter Your 11-Digit Mobile Number to Place an Order and Use the Website Features.",
    "کد تایید به شماره همراه شما ارسال شد، لطفا پس از وارد نمودن کد تایید 'نهایی سازی' را لمس کنید.": "A Verification Code Has Been Sent to Your Mobile Number. Please Enter It and Tap 'Finalize'.",
    "شماره تلفن همراه": "Mobile Number",
    "تصحیح شماره موبایل": "Re-enter Mobile Number",
    "نهایی سازی": "Finalize",
    "دریافت کد تایید": "Receive Verification Code",
    "تایید هویت": "Identity Verification",
    "جهت بهبود روند ثبت و پیگیری سفارش, لطفا نام و نام خانوادگی خود را وارد نمایید.": "To improve the order registration and tracking process, please enter your first and last name.",
    "مثال: علی رضایی": "e.g: John Smith",
    "تکمیل حساب کاربری": "Finalizing your account",
    "ادامه ثبت سفارش": "Continue Order",
    "انتخاب آدرس از روی نقشه": 'Select Address from Map',
    "آدرس دقیق پستی خود را وارد نمائید": "Enter Your Exact Postal Address",
    "نماد اعتماد الکترونیک": "Electronic Trust Symbol",
    "صفحه مورد نظر یافت نشد": "Page Not Found",
    "درباره ما": "About Us",
    "صفحه اصلی سایت": "Homepage",
    "در حال حاضر موردی ثبت نشده است": "No Items Have Been Registered",
    "فروشگاه کلانا": "Cluna Store",
    "افزودن آدرس جدید": "Add New Address",
    "برای ایجاد آدرس های جدید از این بخش استفاده کنید": "Use This Section to Add New Addresses",
    "مثال: خانه": "Example: Home",
    "عنوان آدرس انتخابی": "Selected Address Title",
    "مثال: بلوار کشاورز، خیابان کارگر شمالی، ساختمان سامان، پلاک 1166، واحد 601": "Example: Keshavarz Blvd, Kargar St, Saman Building, No. 1166, Unit 601",
    "ذخیره آدرس": "Save Address",
    "نام این آدرس و آدرس دقیق پستی خود را مشخص کنید.": "Specify This Address Name and Your Exact Postal Address.",
    "موقعیت جغرافیایی خود را مشخص کنید.": "Specify Your Geographic Location.",
    "از حذف این آیتم مطمئن هستید؟": "Are You Sure You Want to Delete This Item?",
    "بله، حذف شود": "Yes, Delete It",
    "انواع": "Variety of ",
    "برای ثبت شکایت خود فرم زیر را تکمیل کنید.": "Complete the Form Below to Submit a Complaint.",
    "عنوان انتقادات و پیشنهادات:": "Title of Feedback and Suggestions:",
    "عنوان انتقادات و پیشنهادات": "Title of Feedback and Suggestions",
    "شماره تماس یا ایمیل: (اختیاری)": "Phone Number or Email: (Optional)",
    "شماره تماس یا ایمیل": "Phone Number or Email",
    "متن انتقادات و پیشنهادات:": "Feedback and Suggestions Text:",
    "متن نظر و پیشنهاد": "Feedback and Suggestion Text",
    "پیام شما با موفقیت ثبت شد": "Your Message Has Been Successfully Submitted",
    "تلفن:": "Phone:",
    "۰۲۱-۴۴۹۹۵۲۹۶": "021-44995296",
    "کیلومتر ۱۷ جاده مخصوص، بعد از خیابان داروپخش، خیابان ۶۳، بن بست چهارم، پلاک 11": "Kilometer 17, Special Road, After DarouPakhsh St, 63rd St, 4th Dead End, No. 11",
    "نام و نام خانوادگی": "Full Name",
    "نام و نام خانوادگی:": "Full Name:",
    "شماره تماس:": "Phone Number:",
    "شماره تماس": "Phone Number",
    "عنوان پیام:": "Message Title:",
    "عنوان پیام": "Message Title",
    "متن پیام:": "Message Text:",
    "متن پیام": "Message Text",
    "ارسال فرم درخواست": "Submit Request Form",
    "محصولات مورد علاقه": "Favorite Products",
    "همین حالا سفارش دهید!": "Order Now!",
    "پیک": "Delivery",
    "حضوری": "In-Person",
    "پیشنهاد ما": "Our Recommendation",
    "خرید اینترنتی": "Online Shopping",
    "ارسال با پیک": "Delivery by Courier",
    "نظرات کاربران": "User Reviews",
    "ناموجود": "Out of Stock",
    "انتخاب": "Select",
    "دسته بندی": "Category",
    "دسته بندی ها": "Categories",
    "برای شروع همکاری اخذ نمایندگی لطفاً فرم زیر را بصورت کامل پر کنید تا کارشناسان ما در اولین فرصت با شما تماس بگیرند.": "To Start a Partnership, Please Fill Out the Form Below Completely So Our Experts Can Contact You as Soon as Possible.",
    "تاریخ تولد:": "Date of Birth:",
    "وضعیت تاهل:": "Marital Status:",
    "تلفن ثابت:": "Landline:",
    "تلفن ثابت": "Landline",
    "موبایل:": "Mobile:",
    "موبایل": "Mobile",
    "ایمیل:": "Email:",
    "ایمیل": "Email",
    "متاهل": "Married",
    "مجرد": "Single",
    "استان": "Province",
    "استان:": "Province:",
    "شهر": "City",
    "شهر:": "City:",
    "وضعیت تملک فروشگاه:": "Store Ownership Status:",
    "مالکیت": "Owned",
    "استیجاری": "Rented",
    "ندارم": "None",
    "آدرس": "Address",
    "ارسال فرم درخواست نمایندگی": "Submit Franchise Request Form",
    "نشانی فروشگاه مورد نظر:": "Address of the desired store:",
    "آدرس:": "Address:",
    "نشانی فروشگاه مورد نظر": "Address of the desired store",
    "متراژ فروشگاه (حداقل 70 متر مربع):": "Store Size (minimum 70 sqm):",
    "متراژ فروشگاه": "Store Size",
    "سوابق کاری و شغل فعلی:": "Work experience and current job:",
    "سوابق کاری و شغل فعلی": "Work experience and current job",
    "مبلغ اجاره فروشگاه:": "Store rent amount:",
    "مبلغ اجاره فروشگاه": "Store rent amount",
    "نحوه آشنایی با کلانا:": "How did you get to know Cluna:",
    "نحوه آشنایی با کلانا": "How did you get to know Cluna",
    "لطفا موارد ستاره دار را تکمیل نمایید.": "Please fill in the starred items.",
    "فرم پذیرش با موفقیت ثبت شد": "The application form was successfully submitted",
    "لطفا منتظر تماس از سمت تیم پشتیبانی باشید!": "Please wait for a call from the support team!",
    "همین حالا اقدام کن": "Take action now",
    "اطلاعاتی را در مورد خودتان وارد نمائید": "Enter your information",
    "اطلاعات شخصی": "Personal information",
    "فایل رزومه خود را بارگذاری نمائید": "Upload your resume file",
    "لینک": "Link",
    "پست الکترونیک": "Email",
    "شماره موبایل": "Mobile number",
    "موارد بیشتر": "More items",
    "جزئیات بیشتری را در مورد خودتان وارد کنید": "Enter more details about yourself",
    "توضیحات": "Description",
    "سوالات": "Questions",
    "لطفا سوالات اضافی را پر کنید": "Please fill in additional questions",
    "آخرین کارفرما": "Last employer",
    "رزومه": "Resume",
    "بازگشت": "Back",
    "با تشکر از ثبت اطلاعات , همکاران پشتیبانی با شما تماس خواهند گرفت": "Thank you for submitting your information, the support team will contact you",
    "ثبت درخواست": "Submit request",
    "این وب سایت می تواند از اطلاعاتی که من داده ام استفاده کند تا مرا برای این سمت در نظر بگیرد.": "This website can use the information I have provided to consider me for this position.",
    "وضعیت شغلی": "Employment status",
    "پیشنهاد ارائه میان وعده هایی کامل از ساعات اولیه روز که از نیازهای اساسی شهرهای بزرگ، به علت کمبود وقت و سرعت بالای زندگی شهری است، ایده بنیانگذاری فروشگاه های کلانا را در سال ۱۳۸۹ برای برطرف کردن این نیاز مهم جامعه در ذهن ما خلق کرد. همکاران ما از ساعت ۷:۳۰ صبح با سخت کوشی خود و کار گروهی، محصولات کلانا را به صورت روزانه و با استفاده از تازه ترین مواد اولیه (که در خانه مصرف می کنیم) تهیه می کنند. آن ها دوستدار متمایز کردن محصولات کلانا با بهره‌گیری از خلاقیت های منحصر به فرد خود هستند. تازگی و سلامت محصولات کلانا در کنار مزه هایی متفاوت و تنوعی محسوس شامل اسنک، کلاب، رپ، کوکی، مافین، دسر، سالاد، نوشیدنی سرد و گرم و ... مکمل خوبی برای ارائه این فعالیت جدید است که امیدواریم از طرف شما به عنوان یک سرویس خوب و قابل اطمینان تجربه شود.": "The idea of ​​offering complete snacks from the early hours of the day, which is one of the basic needs of large cities due to lack of time and high-speed urban life, created the idea of ​​establishing Cluna stores in 1389 to meet this important need of society. Our colleagues, from 7:30 in the morning, by their hard work and teamwork, prepare Cluna's products daily using the freshest raw materials (which we use at home). They love to differentiate Cluna's products by using their unique creativity. The freshness and healthiness of Cluna's products, along with different flavors and tangible variety, including snacks, club sandwiches, wraps, cookies, muffins, desserts, salads, cold and hot drinks, etc., are a good complement to offering this new activity, which we hope will be experienced by you as a good and reliable service.",
    "جستجو محصول": "Search Product",
    "ثبت شد": "Registered",
    "لغو شد": "Cancelled",
    "جستجوی پیک": "Courier Search",
    "پیک یافت شد": "Courier Found",
    "پیک در فروشگاه": "Courier at Store",
    "تحویل داده شد": "Delivered",
    "ریفاند به حساب بانکی": "Refund to Bank Account",
    "ریفاند به کیف پول": "Refund to Wallet",
    "حساب کاربری با موفقیت به روزرسانی شد!": "Account Successfully Updated!",
    "بله، خارج میشوم": "Yes, I will log out",
    "در این صورت از حساب کاربری خود خارج خواهید شد. ادامه میدهید؟": "You will be logged out of your account. Do you want to continue?",
    "بازخورد شما با موفقیت ثبت شد!": "Your feedback has been successfully recorded!",
    "ابی": "Blue",
    "زرد": "Yellow",
    "سفید": "White",
    "مشکی": "Black",
    "خاکستری": "Gray",
    "سبز": "Green",
    "خروج": "Exit",
    "پشتیبانی": "Support",
    "صندوق پیام": "Inbox",
    "تراکنش های مالی": "Transactions",
    "آدرس های من": "My Addresses",
    "اطلاعات کاربری": "User Information",
    "سفارشات": "Orders",
    "متن نظر، انتقاد و یا پیشنهاد": "Text of Comment, Criticism, or Suggestion",
    "نظر، انتقاد و یا پیشنهاد خود را راجع به سرویس دهی و کیفیت سفارش خود با ما به اشتراک بگذارید.": "Share your comments, criticisms, or suggestions regarding the service and quality of your order with us.",
    "ثبت نظر و امتیاز": "Comment & Rate",
    "شارژ کیف پول درون برنامه ای": "In-app Wallet Recharge",
    "مبلغ ورودی به تومان": "Amount in Tomans",
    "مبلغ دلخواه خود را جهت افزایش اعتبار را وارد نمایید": "Enter your desired amount to increase credit",
    "ذخیره تغییرات حساب کاربری": "Save Account Changes",
    "تاریخ تولد": "Date of Birth",
    "نتیجه ای یافت نشد": "No Results Found",
    "تاریخ": "Date",
    "عنوان": "Title",
    "فاکتور خرید": "Purchase Invoice",
    "زمان سفارش": "Order Time",
    "نام فروشگاه": "Store Name",
    "عدد": "Number",
    "مبلغ کل سفارش:": "Total Order Amount:",
    "هزینه پیک:": "Courier Cost:",
    "سفارش حضوری": "In-Person Order",
    "سفارش دلیوری": "Delivery Order",
    "نوع سفارش:": "Order Type:",
    "وضعیت سفارش": "Order Status",
    "زمان ثبت": "Registration Time",
    "سبد خرید": "Shopping Cart",
    "نوع/جزییات سفارش": "Order Type/Details",
    "کد سفارش": "Order Code",
    "افزایش اعتبار": "Increase Credit",
    "اعتبار:": "Credit:",
    "درصد تخفیف": "% Discount",
    "دانلود مستقیم اندروید": "Cluna for Android",
    "دانلود از کافه بازار": "Cluna on CafeBazar",
    "سبد خرید خود را با این پیشنهادات تکمیل کنید!": "Add these suggestions to your basket!",
    "ملزومات سفارش": "Order options",
    "انصراف": "Discard",
    "وبسایت": "Website",
    "حساب کاربری": "User Profile",
    "ورود / عضویت": "SignIn / SignUp",
    "ثبت و ارسال بازخورد": "Submit your review",
    "در صورت ادامه سبد خرید شما خالی و فروشگاه شما تغییر خواهد کرد، ادامه میدهید؟": "If you continue, your shopping cart will be empty and your store will change, do you want to continue?",
    "ادامه میدهم": "I will continue",
    "مثال: 09123456789": "Example: 09123456789",
    "جهت تکمیل سفارش و مشاهده خرید خود وارد 'سبد خرید' شوید.": "To complete your order and view your purchases, enter your 'Shopping Cart'.",
    "مشاهده سبد خرید": "Go To Order Basket",
    "نام و نام خانوادگی خود را وارد نمایید.": "Enter your first and last name, Please.",
    // "": "",
};
